import './App.css';
import {Col, Container, Nav, Row} from "react-bootstrap";
import React, {useContext, useEffect} from "react";
import {Outlet, useLoaderData, useLocation, useRouteLoaderData} from "react-router";
import {TopNav} from "./navigation/TopNav";
import {LeftNav} from "./navigation/LeftNav";
import {BottomNav} from "./navigation/BottomNav";
import {BackendContext, BackendDispatchContext} from "./context/Backend";

function App() {

    const location = useLocation();

    return (
        <Container fluid={true} className={"bg-light"}>
            <Row className={"fixed-top"}>
                <Col className={"bg-light-subtle"}>
                    {/*<Container fluid={true} className={"p-0 "} >*/}
                        <TopNav/>
                    {/*</Container>*/}
                </Col>
            </Row>

            <Row className={"mainContent"}>
                <Col>
                    <Container fluid={location.pathname==='/login'?true:("md")} className={"container h-100"}>
                        <Row className={"h-100"}>
                            {/*<LeftNav/>*/}
                            <Col className={"p-0"}>
                                <Outlet/>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>

            <Row className={"fixed-bottom"}>
                <Col>
                    <BottomNav />
                </Col>
            </Row>
        </Container>
    );
}

export default App;
